export default {
  sidebar: state => state.sidebar,
  pagesize: state => state.pagesize,

}



// WEBPACK FOOTER //
// ./src/store/getters.js